export default __webpack_public_path__ + "static/media/player-lauren-colour-mob@2x.1d897134.png";